let _index = 0;
let _timer: any;
export const onBackDoor = (fn: () => void, n = 10) => {
  _index++;
  if (_timer) clearTimeout(_timer);
  _timer = setTimeout(() => {
    _index = 0;
  }, 500);
  if (_index == n) {
    fn();
  }
};
